/**
 * @module SearchSuggestion
 */
const SearchSuggestion = (() => {
  const renderResults = (input, results, callback) => {
    const filteredResults = []
    let flags = [], l = results.length, i
    for( i=0; i<l; i++) {
      if(!results[i].value) continue
      if(flags[results[i].value]) continue

      flags[results[i].value] = true
      filteredResults.push(results[i])
    }
    const length = filteredResults.length < 5 ? filteredResults.length : 5

    let template = '<ul class="c-search-suggestion__list">'
    for (let i = 0; i < length; i++) {
      template += `
        <li class="c-search-suggestion__list-item">
          <button class="c-search-suggestion__result">${filteredResults[i].label}</button>
        </li>
      `
    }
    template += '</ul>'

    const container = input.parentNode
    const suggestion = document.createElement('div')
    suggestion.classList.add('c-search-suggestion')
    suggestion.innerHTML = template

    const prevSuggestion = container.querySelector('.c-search-suggestion')
    if (prevSuggestion) container.removeChild(prevSuggestion)
    if (filteredResults.length > 0) container.insertBefore(suggestion, input.nextSibling)

    const buttons = suggestion.querySelectorAll('.c-search-suggestion__result')
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', (e) => {
        e.preventDefault()
        callback(filteredResults[i])
      })
    }
  }

  const show = (selectorInput, results, callback) => {
    const input = typeof selectorInput == 'string' ? document.querySelector(selectorInput) : selectorInput
    if (!input) return

    renderResults(input, results, callback)
  }

  const hideAll = () => {
    const suggestions = document.querySelectorAll('.c-search-suggestion')
    for (let i = 0; i < suggestions.length; i++) {
      suggestions[i].parentNode.removeChild(suggestions[i])
    }
  }

  return {
    show,
    hideAll
  }
})()

export default SearchSuggestion



// WEBPACK FOOTER //
// app/javascript/scripts/components/SearchSuggestion.js